import { SvgIcon } from 'components/helpers/SvgIcon';
import styles from './CurrentSelection.module.scss';

interface LanguageLink {
  name: string;
  domain: string;
  lang?: string;
}

interface CurrentSelectionProps {
  country: string;
  languages: LanguageLink[];
}

const getAbsoluteUrl = (url: string): string => {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // If it's a relative URL, make it absolute
  return `https://${url}`;
};

export const CurrentSelection = ({ country, languages }: CurrentSelectionProps) => {
  return (
    <div className={styles.locationSelector} aria-label={`${country} languages`}>
      <div aria-hidden="true">
        <SvgIcon icon="locationSelector" />
      </div>
      <div className={styles.contentContainer}>
        <h3 className={styles.countryName}>{country}</h3>
        <ul className={styles.languageContainer}>
          {languages.map((language, index) => (
            <li key={index} className={styles.languageWrapper}>
              <a
                href={getAbsoluteUrl(language.domain)}
                className={styles.language}
                target="_self"
                aria-label={`${country} ${language.name}`}
                lang={language.lang}
                hrefLang={language.lang}
              >
                {language.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
